module.exports = __webpack_public_path__ + "img/bankless.683e7e58.png";